var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"clearable":false,"options":_vm.estates,"value":_vm.selectValue(_vm.selected),"disabled":_vm.disabled},on:{"input":function (val) { return _vm.estateChange(val); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }